import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ReactComponent as BnplBlob } from '@/img/icons/bnpl-blob.svg';
import { ReactComponent as BnplCalendar } from '@/img/icons/bnpl-calendar.svg';

function BnplIllustration() {
    return (
        <Box className="bnpl-top-banner__illustration">
            <BnplBlob className="bnpl-top-banner__illustration-blob" />
            <BnplCalendar className="bnpl-top-banner__illustration-calendar" />
        </Box>
    );
}

function BnplTopBanner({ onLearnMore, learnMoreText }) {
    const { t } = useTranslation();

    const scrollToPayment = () => {
        document.getElementById('payment-component')?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <Box className="bnpl-top-banner">
            <Box className="bnpl-top-banner__content">
                <Typography className="bnpl-top-banner__headline" variant="subtitle1">
                    <span className="bnpl-top-banner__headline-highlight">{t('BnplTopBanner.HeadlineBold')}</span>
                </Typography>
                <Typography className="bnpl-top-banner__subtext" variant="body2">
                    {t('BnplTopBanner.Subtext')}
                </Typography>
                <button className="bnpl-top-banner__learn-more" onClick={onLearnMore || scrollToPayment}>
                    {learnMoreText || t('BnplTopBanner.LearnMore')}
                    <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginLeft: '4px', verticalAlign: 'middle'}}>
                        <path fillRule="evenodd" clipRule="evenodd" d="M0.0475113 3.37795C0.0158371 3.40945 0 3.45144 0 3.50394C0 3.55643 0.0158371 3.60367 0.0475113 3.64567L3.3733 6.93701C3.40498 6.979 3.44721 7 3.5 7C3.55279 7 3.59502 6.979 3.6267 6.93701L6.95249 3.64567C6.98416 3.60367 7 3.55643 7 3.50394C7 3.45144 6.98416 3.40945 6.95249 3.37795L6.63575 3.06299C6.60407 3.021 6.56184 3 6.50905 3C6.45626 3 6.40875 3.021 6.36652 3.06299L3.5 5.91339L0.633484 3.06299C0.591252 3.021 0.543741 3 0.49095 3C0.43816 3 0.395928 3.021 0.364253 3.06299L0.0475113 3.37795Z" fill="var(--general-colors-primary)"/>
                    </svg>
                </button>
            </Box>
            <BnplIllustration />
        </Box>
    );
}

export default React.memo(BnplTopBanner);
